"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const NonBinary = _ref => {
  let {
    title = 'NonBinary',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 1C12.75 0.585786 12.4142 0.25 12 0.25C11.5858 0.25 11.25 0.585786 11.25 1V2.41654L9.40356 1.35049C9.04484 1.14339 8.58615 1.26629 8.37904 1.62501C8.17194 1.98373 8.29484 2.44243 8.65356 2.64953L10.4978 3.71429L8.65356 4.77905C8.29484 4.98616 8.17194 5.44485 8.37904 5.80357C8.58615 6.16229 9.04484 6.2852 9.40356 6.07809L11.25 5.01205L11.25 7.53469C7.18341 7.91279 4 11.3346 4 15.5C4 19.9183 7.58172 23.5 12 23.5C16.4183 23.5 20 19.9183 20 15.5C20 11.3346 16.8166 7.91279 12.75 7.53469V5.01461L14.592 6.0781C14.9507 6.28521 15.4094 6.1623 15.6165 5.80359C15.8236 5.44487 15.7007 4.98617 15.342 4.77907L13.4978 3.71429L15.342 2.64952C15.7007 2.44241 15.8236 1.98372 15.6165 1.625C15.4094 1.26628 14.9507 1.14337 14.592 1.35048L12.75 2.41397V1ZM12 9C8.41015 9 5.5 11.9101 5.5 15.5C5.5 19.0899 8.41015 22 12 22C15.5899 22 18.5 19.0899 18.5 15.5C18.5 11.9101 15.5899 9 12 9Z",
    fill: "black"
  }));
};
var _default = exports.default = (0, _ikon.default)(NonBinary);
NonBinary.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "NonBinary",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'NonBinary'",
        "computed": false
      },
      "required": false
    }
  }
};